<template>
  <v-menu
    offset-y
    bottom
    left
    :data-testid="testId"
    :close-on-content-click="closeOnContentClick"
  >
    <template v-slot:activator="{ on }">
      <slot name="activator" :on="on"></slot>
    </template>
    <v-list nav dense>
      <v-list-item-group
        color="blue"
        :value="selectedOption"
        class="header-menu"
      >
        <template v-for="(option, index) in options">
          <v-divider v-if="option.divider" :key="`divider_${index}`" />
          <v-list-item
            :key="`${option.id}_${index}`"
            :value="option.id"
            :data-testid="option.testId"
            :data-tourid="option.tourId"
            @click="handleItemClick(option)"
          >
            <div class="d-flex justify-center">
              <v-icon
                v-if="option.icon"
                size="20"
                color="blue-grey darken-2"
                class="ma-0 pa-0 mr-1"
              >
                {{ option.icon }}</v-icon
              >

              <span class="blue-grey--text text--darken-2 ma-0 pa-0 body-2">
                {{ option.title }}
              </span>
            </div>
          </v-list-item>
        </template>
      </v-list-item-group>
    </v-list>
  </v-menu>
</template>

<script>
export default {
  name: 'Menu',

  props: {
    options: {
      type: Array,
      required: true,
    },

    testId: {
      type: String,
      required: false,
    },

    tourId: {
      type: String,
      required: false,
    },

    closeOnContentClick: {
      type: Boolean,
      default: true,
    },

    selectedOption: {
      type: String,
      required: false,
    },
  },

  methods: {
    handleItemClick(option) {
      this.$emit('click', option)
      if (option.action) option.action()
    },
  },
}
</script>
<style lang="css" scoped>
.header-menu > .v-list-item:hover {
  background-color: var(--v-blue-grey-lighten3);
}
</style>
